import { render, staticRenderFns } from "./vehicle.block.vue?vue&type=template&id=3c47b8ff&scoped=true"
import script from "./vehicle.block.vue?vue&type=script&lang=js"
export * from "./vehicle.block.vue?vue&type=script&lang=js"
import style0 from "./vehicle.block.vue?vue&type=style&index=0&id=3c47b8ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c47b8ff",
  null
  
)

export default component.exports